/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InstallmentPlanMessageCreateRequest = {
    senderId: string;
    text?: string;
    documentIdList?: Array<string>;
    type: InstallmentPlanMessageCreateRequest.type;
};
export namespace InstallmentPlanMessageCreateRequest {
    export enum type {
        TEXT = 'TEXT',
        FILE = 'FILE',
        IMAGE = 'IMAGE',
    }
}

